import type { Channel, UserResponse } from "stream-chat"

export function getChannelCreatorId(channel: Channel) {
  return (
    channel && channel.data && (channel.data.created_by_id || (channel.data.created_by as UserResponse | undefined)?.id)
  )
}
